import type { IAddinCommand } from 'owa-addins-types';
import type Addin from '../store/schema/Addin';
import { owaComputedFn } from 'owa-computed-fn';

/**
 * This function retrieves the group label, provider, and type string for a specific add-in.
 * @param addin addin to get metadata for
 * @returns An object containing groupLabel, provider, typeString, name, or undefined if not found
 */
export const getAddinGroupMetadataFromAddin: (addin: Addin | undefined) =>
    | {
          groupLabel?: string;
          providerName?: string;
          typeString?: string;
          name?: string;
      }
    | undefined = owaComputedFn(
    (
        addin: Addin | undefined
    ):
        | {
              groupLabel?: string;
              providerName?: string;
              typeString?: string;
              name?: string;
          }
        | undefined => {
        if (addin) {
            const addinCommands = addin.AddinCommands as Map<string, IAddinCommand>;
            for (const command of addinCommands.values()) {
                const groupLabel = command.get_GroupLabel?.() ?? undefined;
                const providerName = command.get_ProviderName?.() ?? undefined;
                const typeString = command.get_TypeString?.() ?? undefined;
                const name = command.get_ExtensionDisplayName?.() ?? undefined;
                return { groupLabel, providerName, typeString, name };
            }
        }
        return undefined;
    }
);
